import { PANCAKE_DARK, PANCAKE_LIGHT, WHITELABEL_DARK, WHITELABEL_LIGHT, WAFFLE_DARK, WAFFLE_LIGHT } from '@bubble-ui/particle-design-versions';
var lightModeColors = {
  default: '#0B051D',
  gray: '#959391',
  inverse: '#F9F8F5'
};
var darkModeColors = {
  default: '#F9F8F5',
  gray: '#959391',
  inverse: '#0B051D'
};
var fillColors = {
  [WHITELABEL_LIGHT]: lightModeColors,
  [WHITELABEL_DARK]: darkModeColors,
  [WAFFLE_LIGHT]: lightModeColors,
  [WAFFLE_DARK]: darkModeColors,
  [PANCAKE_LIGHT]: lightModeColors,
  [PANCAKE_DARK]: darkModeColors
};
export var getDefaultStyleSheet = _ref => {
  var {
    designVersion,
    inverse,
    gray
  } = _ref;
  var color = gray ? 'gray' : inverse ? 'inverse' : 'default';
  var fillColorByTheme = fillColors[designVersion][color];
  return {
    rootStyle: {
      fill: fillColorByTheme
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map